"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (prefix = '') => {
  return [_path || (_path = _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.861 16.268l-.83-.83A4 4 0 018.554 9.96L7.41 8.817a16.798 16.798 0 00-2.413 2.269c-.31.351-.565.667-.757.915a18.76 18.76 0 002.073 2.264C7.888 15.715 9.9 17.001 12 17.001c.979 0 1.943-.279 2.861-.733zm1.478 1.478l2.248 2.248 1.414-1.415L5.43 4.008 4.015 5.422l1.97 1.969a19.052 19.052 0 00-2.489 2.373A21.273 21.273 0 001.796 12a16.64 16.64 0 001.134 1.567c.477.59 1.17 1.377 2.029 2.168C6.641 17.285 9.129 19 11.999 19c1.597 0 3.07-.531 4.34-1.255zm-6.271-6.272l2.45 2.45c-1.454.39-2.831-1.025-2.45-2.45zm5.895 1.067c.349-2.546-1.946-4.863-4.512-4.511l4.512 4.51zm4.54 1.697c-.388.441-.86.94-1.4 1.442l-1.416-1.415A18.874 18.874 0 0019.76 12a18.77 18.77 0 00-2.074-2.265C16.111 8.286 14.1 7.001 12 7.001c-.47 0-.936.064-1.396.181L9.02 5.599C9.945 5.233 10.945 5 12 5c2.87 0 5.359 1.715 7.041 3.264 1.194 1.1 2.3 2.357 3.163 3.736-.238.355-.474.711-.732 1.053a20.47 20.47 0 01-.968 1.184z"
  }))];
};

exports.default = _default;